import './BatchApplicationOfLaborTemplates.scss';
import NavBar from './nav-bar/NavBar';
import ProfileTick from '../../assets/icons/profiletick.svg';
import DropDownWithButton from './dropdown-with-button/DropDownWithButton';
const BatchApplicationOfLaborTemplates = () => {
    const applicableCount = 3;
    return (
        <div className="batchApplicationOfLaborTemplates">
            <NavBar />
            <div className="header">
                <div className="leftContainer">
                    <div className="title">근로템플릿 일괄적용</div>

                    <div className="subTitle">기존 일정이 있는 직원은 새로운 일정으로 변경됩니다</div>
                </div>

                <div className="rightContainer">
                    <div className="applicableButtonGreen">
                        <img className="image" src={ProfileTick} alt="" />
                        <div className="textLabel">적용대상 {applicableCount}명</div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="leftContainer">
                    <div className="dropDownWrapper">
                        <DropDownWithButton
                            options={['test']}
                            label="근로템플릿 선택*"
                            placeHolder="템플릿 선택"
                            buttonText={'근로템플릿 설정'}
                            buttonAction={() => {}}
                        />
                    </div>
                </div>

                <div className="rightContainer"> </div>
            </div>
        </div>
    );
};

export default BatchApplicationOfLaborTemplates;
